import React from 'react';
import { useGetCDLineLimitsQuery } from 'API/order/fees/FeeApi';
import { Notification } from 'ui-toolkit';
import { validateAll } from './validate';
import { selectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { useAppSelector } from 'store/store';
import { assertDefined } from 'utilities/Assertions';
import { IValidationProps } from './Validation';

export const CDValidationContainer: React.FC<IValidationProps> = ({
  className,
  currentLineItem,
  sections,
  sectionDefinitions,
}) => {
  const { data: rules = [] } = useGetCDLineLimitsQuery();
  const { transactionCategory } = useAppSelector((state) => ({
    transactionCategory: selectCurrentOrder(state).data?.transaction.transaction_category,
  }));
  assertDefined(transactionCategory);

  const results = validateAll({
    sections,
    sectionDefinitions,
    rules,
    transactionCategory,
    currentLineItem,
  });

  return (
    <>
      {!!results.length && !!className && (
        <div className={className} data-test-id={'cd-limit-validation-warning-wrapper'}>
          {results.map((t) => (
            <Notification key={t} message={t} type={'warning'} data-test-id="cd-limit-validation-warning" />
          ))}
        </div>
      )}
      {!!results.length &&
        !className &&
        results.map((t) => (
          <Notification key={t} message={t} type={'warning'} data-test-id="cd-limit-validation-warning" />
        ))}
    </>
  );
};
